<template>
  <button type="button"
          class="serp__filters--marked-item-button q-btn q-btn-sm q-btn-light q-btn-sm q-me-2 q-mb-2 q-position-relative q-position-relative q-rounded-3 q-shadow-sm"
          v-for="selectedFilter in activeFilter" :key="selectedFilter">
    {{ filtersStore.getFilterLabelByFilterName(filterName) }}: {{ selectedFilter }}
    <a class="q-ms-1 q-stretched-link q-btn-close"
       @click.prevent="filtersStore.updateFilter(filterName, selectedFilter)"></a>
  </button>
</template>

<script setup lang="ts">
import {defineProps} from "vue";
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";

defineProps(['activeFilter', 'filterName'])

const filtersStore = useFiltersStore();
</script>
<style>
.serp__filters--marked-item-button{
  text-wrap: nowrap;
}
.serp__filters--marked-item-button:hover, .serp__filters--marked-item-button:focus {
  border: 1px solid transparent;
}

</style>
